import type { ButtonHTMLAttributes, ReactNode } from 'react'

type EsButtonVariant = 'primary' | 'secondary' | 'ghost'

const variantClass: Record<EsButtonVariant, string> = {
  primary:
    'bg-es-signal text-es-white border-es-signal hover:bg-es-deep hover:border-es-deep',
  secondary:
    'bg-es-white text-es-deep border-es-signal hover:bg-es-haze',
  ghost:
    'bg-transparent text-es-signal border-transparent hover:text-es-deep hover:bg-es-haze/60',
}

export function EsButton({
  variant = 'primary',
  className = '',
  children,
  type = 'button',
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: EsButtonVariant
  children: ReactNode
}) {
  return (
    <button
      type={type}
      className={`font-esDisplay font-semibold text-[15px] leading-none rounded-[var(--radius-sm)] px-6 py-3 border-[1.5px] transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed ${variantClass[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  )
}
